import axios from 'axios'

const mauthorResourse = async (id) => {
  const url = `${window.viewer.resourcesMauthorApi}${id}`
  try {
    const response = await axios.get(url, id)
    return response.data.url
  } catch (error) {
    console.error(error)
    return null
  }
}

const flipbookResourse = async (id) => {
  const url = `${window.viewer.resourcesFlipbookApi}${id}`
  try {
    const response = await axios.get(url, id)
    return response.data.url
  } catch (error) {
    console.error(error)
    return null
  }
}

export { mauthorResourse, flipbookResourse }
